import { Box } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import SimpleBarReact from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
// material

// ----------------------------------------------------------------------

const RootStyle = styled('div')({
  flexGrow: 1,
  height: '100%',
  overflow: 'hidden',
  position: 'relative'
});

const SimpleBarStyle = styled(SimpleBarReact)(({ theme }) => ({
  maxHeight: '100%',
  '& .simplebar-scrollbar': {
    '&:before': {
      backgroundColor: alpha(theme.palette.grey[600], 0.48),
      borderRadius: '4px'
    },
    '&.simplebar-visible:before': {
      opacity: 1
    }
  },
  '& .simplebar-track.simplebar-vertical': {
    width: 8,
    right: 0,
    left: 'auto',
    background: 'transparent'
  },
  '& .simplebar-track.simplebar-horizontal': {
    height: 8,
    bottom: 0,
    background: 'transparent'
  },
  '& .simplebar-track.simplebar-horizontal .simplebar-scrollbar': {
    height: 8
  },
  '& .simplebar-mask': {
    zIndex: 'inherit',
    overflow: 'hidden'
  },
  '& .simplebar-content-wrapper': {
    overflow: 'auto',
    height: '100%',
    width: '100%'
  },
  '& .simplebar-content': {
    height: '100%',
    width: '100%'
  }
}));

// ----------------------------------------------------------------------

Scrollbar.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
  timeout: PropTypes.number,
  clickOnTrack: PropTypes.bool,
  autoHide: PropTypes.bool
};

export default function Scrollbar({ 
  children, 
  sx, 
  timeout = 500,
  clickOnTrack = true,
  autoHide = true,
  ...other 
}) {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  if (isMobile) {
    return (
      <Box sx={{ overflowX: 'auto', ...sx }} {...other}>
        {children}
      </Box>
    );
  }

  return (
    <RootStyle>
      <SimpleBarStyle 
        timeout={timeout} 
        clickOnTrack={clickOnTrack}
        autoHide={autoHide}
        forceVisible="y"
        sx={sx} 
        {...other}
      >
        {children}
      </SimpleBarStyle>
    </RootStyle>
  );
}
